__webpack_require__.p = "/Typing-Study-Game/";